<template>
  <div class="my-prop">
    <comHead :headObj="headObj"></comHead>
    <!--彩矿兑换列表--->
    <caikuangExchangeList :from="'prop'" :list="list" :institutional="institutional" @catNameFnc="catNameFnc"></caikuangExchangeList>
  </div>
</template>

<script>
import comHead from './../../components/header.vue'
import caikuangExchangeList from '@/view/home/components/caikuangExchangeList'
import { get } from './../../utils/httpService'
export default {
  name: 'prop',
  data () {
    return {
      headObj: {
        backgroundc: '#fff',
        color: '#222',
        title: '我的道具'
      },
      list: [],
      institutional: []
    }
  },
  components: {
    comHead,
    caikuangExchangeList
  },
  created () {
    this.getCats()
  },
  methods: {
    async fetchData (name) {
      try {
        this.list = await get(`/api/user/items?cat=${name}`)
        console.log('Fetched data:', this.list)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    },
    async getCats () {
      try {
        this.institutional = await get('/api/shop/item/cats')
        this.institutional.unshift('全部')
        console.log('Fetched data:', this.institutional)
        this.fetchData('')
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    },
    catNameFnc (e) {
      if (e === '全部')e = ''
      this.fetchData(e)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/view/myProp/index.vue